import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  listfaq,
  createFaq,
  updateFaq,
  deleteFaq,
  faqs,
} from "@/services/faq";

@Module({
  namespaced: true,
})
export default class Item extends VuexModule {
  // state
  faqList = [];
  faqData = {};

  @Action
  public async createFaq(payload) {
    try {
      const data = await createFaq(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateFaq(payload) {
    try {
      const data = await updateFaq(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchFaqsList() {
    try {
      const data = await listfaq();
      this.context.commit("setFaqList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async sendFaqData(payload) {
    try {
      this.context.commit("setCurrentFaqData", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchFaqs(payload) {
    try {
      const data = await faqs(payload.scope);
      this.context.commit("setFaqList", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async deleteFaq(payload) {
    try {
      const data = await deleteFaq(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  // mutations

  @Mutation
  public setFaqList(data: any) {
    this.faqList = data;
  }

  @Mutation
  public setCurrentFaqData(data: any) {
    this.faqData = data;
  }

  // getters
  get GetFaqList() {
    return this.faqList;
  }
}
